<div *ngIf="control.invalid && (control.dirty || control.touched)">
  <ng-container *ngIf="customTemplate; else defaultTemplate">
    <ng-container *ngTemplateOutlet="customTemplate; context: { $implicit: errorMessage }"></ng-container>
  </ng-container>
  <ng-template #defaultTemplate>
    <small *ngIf="errorMessage">{{ errorMessage }}</small>
  </ng-template>
</div>